import { PlanCurrencyCode } from '../types/api';

export const DEFAULT_PRICING_CURRENCY: PlanCurrencyCode = 'USD';

export const mapUserLocationToCurrency = (userLocation: string): PlanCurrencyCode => {
  const normalized = userLocation.trim().toLowerCase();

  if (normalized === 'india' || normalized.includes('india')) {
    return 'INR';
  }

  if (
    normalized === 'us' ||
    normalized.includes('united states') ||
    normalized.includes('usa') ||
    normalized.includes('america')
  ) {
    return 'USD';
  }

  if (normalized === 'canada' || normalized.includes('canada')) {
    return 'CAD';
  }

  if (normalized === 'eu' || normalized.includes('europe') || normalized.includes('euro')) {
    return 'EUR';
  }

  return DEFAULT_PRICING_CURRENCY;
};
